import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import ClipboardText from 'ui-library/ClipboardText';
import {GRAY_DARK} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {USER_DEFINED_VIEW_SCHEMA} from '../AnalyticsWarehouseConstants';
import {WarehouseTableData} from '../warehouseModelsDataLayout';
import WarehouseDiagramUnrelatedTablesButton from './WarehouseDiagramUnrelatedTablesButton';

export interface WarehouseDiagramTableHeaderProps {
  schemaName: string;
  tableData: WarehouseTableData;
  isFocus: boolean;
  numberUnpopulatedRelatedTables: number;
}

export default function WarehouseDiagramTableHeader(props: WarehouseDiagramTableHeaderProps): JSX.Element {
  const icon = props.schemaName === USER_DEFINED_VIEW_SCHEMA ? 'head-side-gear' : 'warehouse-table';
  return (
    <div
      aria-current={props.isFocus ? 'true' : undefined}
      className={classNames(css(styles.wrapper))}
      {...getTestProps({component: 'WarehouseDiagramTableHeader', element: 'root'})}
    >
      <div
        className={classNames(
          'u-vertical-center-items',
          props.isFocus && 'tableHeader--focusTable',
          css(styles.tableIconWrapper)
        )}
      >
        <BenchlingIcon
          className={classNames(
            css(styles.tableIcon),
            css(props.isFocus ? styles.focusTableIcon : styles.notFocusTableIcon)
          )}
          icon={icon}
        />
        <div className={css(styles.tableName)}>
          <div className="clipboardIcon-wrapper--flex">
            <ClipboardText clipboardData={`${props.schemaName}.${props.tableData.name}`}>
              <div className={css(styles.wrappedTableName)}>{props.tableData.name}</div>
            </ClipboardText>
          </div>
        </div>
      </div>
      <div>
        {props.numberUnpopulatedRelatedTables > 0 && (
          <WarehouseDiagramUnrelatedTablesButton
            tableData={props.tableData}
            numberUnpopulatedRelatedTables={props.numberUnpopulatedRelatedTables}
          />
        )}
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    padding: '4px 6px',
    fontSize: 14,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: '100%',
  },
  tableName: {
    marginLeft: 4,
    whiteSpace: 'nowrap',
  },
  tableIconWrapper: {
    display: 'flex',
  },
  tableIcon: {
    marginBottom: 1,
  },
  focusTableIcon: {
    color: 'white',
  },
  notFocusTableIcon: {
    color: GRAY_DARK,
  },
  wrappedTableName: {
    overflowX: 'hidden',
    maxWidth: 185,
    textOverflow: 'ellipsis',
  },
});
